import type { ReactNode } from "react";

import type { LucideIcon } from "lucide-react";
import { motion } from "motion/react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  /** Sabab va keyingi qadam — bo'sh holat hech qachon yolg'iz "hech narsa yo'q" emas. */
  text?: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, text, action }: EmptyStateProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="flex flex-col items-center gap-3 px-4 py-14 text-center"
    >
      <span className="relative grid size-16 place-items-center">
        <span className="bg-primary/10 absolute inset-0 animate-ping rounded-full [animation-duration:2.8s]" />
        <span className="bg-tile-coral text-tile-coral-strong animate-float relative grid size-14 place-items-center rounded-2xl shadow-sm">
          <Icon className="size-6" aria-hidden />
        </span>
      </span>
      <p className="font-semibold">{title}</p>
      {text ? <p className="text-muted-foreground max-w-sm text-sm">{text}</p> : null}
      {action}
    </motion.div>
  );
}
